function FileUploadButton({ changeHandler }: { changeHandler: any }) {
  return (
    <div className="flex w-full items-center justify-center bg-grey-lighter">
      <label className="w-34 inline-flex items-center tracking-wide cursor-pointer">
        <svg
          className="fill-current text-green-500 w-6 h-6 hover:text-green-900"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
        </svg>
        {/* <span className="ml-2 text-sm leading-normal">upload</span> */}
        <input type="file" className="hidden" onChange={changeHandler}/>
      </label>
    </div>
  );
}

export default FileUploadButton;
